import React from 'react';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import {Card, CardBody, CardTitle, CardText} from 'reactstrap';
import {COLORS} from '../../../common/constants';
import styled from 'styled-components';

const DashboardCard = styled(Card)`
  &&& {
    border-radius: 8px;
    background-color: ${({backgroundcolor}) => backgroundcolor};
    color: ${({color}) => color};
  }
`;

const DashboardCardTitle = styled(CardTitle)`
  &&& {
    font-size: 22px;
    font-weight: 700;
  }
`;

const DashboardCardText = styled(CardText)`
  &&& {
    font-size: 18px;
  }
`;

const NumberDashboard = ({t, data, backgroundColor, color}) => {
  const {title, value = null} = data;
  return (
    <>
      <DashboardCard backgroundcolor={backgroundColor} color={color}>
        <CardBody>
          <DashboardCardTitle>{value}</DashboardCardTitle>
          <DashboardCardText>{t(title)}</DashboardCardText>
        </CardBody>
      </DashboardCard>
    </>
  );
};

NumberDashboard.defaultProps = {
  backgroundColor: COLORS.WHITE,
  color: COLORS.BLACK,
};

NumberDashboard.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  }).isRequired,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
};

export default compose(
  withTranslation('dashboard'),
)(NumberDashboard);
